import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { ACTION } from './action-types';
import * as actions from './action-types';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { MyNotificationsState } from './types';

export const INITIAL_NOTIFICATIONS_STATE: MyNotificationsState = {
  fetchingLoadConsent: false,
  fetchingDeleteConsent: false,
  fetchingVerifyCode: false,
  fetchingSaveSubscription: false,
  fetchingLoadConsents: false,
  validation: {},
  ...INITIAL_SIMPLEFORM_STATE
};

export const reducers: { [indexer: string]: Reducer<MyNotificationsState> } = {

  [ACTION.REQUEST_DELETE_CONSENT]: (state: MyNotificationsState, action: actions.RequestDeleteConsent): MyNotificationsState => {

    return {
      ...state,
      fetchingDeleteConsent: true
    };
  },

  [ACTION.RECEIVE_DELETE_CONSENT]: (state: MyNotificationsState, action: actions.ReceiveDeleteConsent): MyNotificationsState => {

    return {
      ...state,
      fetchingDeleteConsent: false
    };
  },

  [ACTION.FAIL_DELETE_CONSENT]: (state: MyNotificationsState, action: actions.FailDeleteConsent): MyNotificationsState => {

    return {
      ...state,
      fetchingDeleteConsent: false
    };
  },

  [ACTION.REQUEST_VERIFY_CODE]: (state: MyNotificationsState, action: actions.RequestVerifyCode): MyNotificationsState => {

    return {
      ...state,
      fetchingVerifyCode: true
    };
  },

  [ACTION.RECEIVE_VERIFY_CODE]: (state: MyNotificationsState, action: actions.ReceiveVerifyCode): MyNotificationsState => {

    return {
      ...state,
      fetchingVerifyCode: false
    };
  },

  [ACTION.FAIL_VERIFY_CODE]: (state: MyNotificationsState, action: actions.FailVerifyCode): MyNotificationsState => {

    return {
      ...state,
      fetchingVerifyCode: false
    };
  },

  [ACTION.REQUEST_SAVE_SUBSCRIPTION]: (state: MyNotificationsState, action: actions.RequestSaveSubscription): MyNotificationsState => {

    return {
      ...state,
      fetchingSaveSubscription: true
    };
  },

  [ACTION.RECEIVE_SAVE_SUBSCRIPTION]: (state: MyNotificationsState, action: actions.ReceiveSaveSubscription): MyNotificationsState => {

    return {
      ...state,
      fetchingSaveSubscription: false
    };
  },

  [ACTION.FAIL_SAVE_SUBSCRIPTION]: (state: MyNotificationsState, action: actions.FailSaveSubscription): MyNotificationsState => {

    return {
      ...state,
      fetchingSaveSubscription: false
    };
  },

  [ACTION.REQUEST_LOAD_PERMISSION]: (state: MyNotificationsState, action: actions.RequestLoadPermission): MyNotificationsState => {

    return {
      ...state,
      fetchingLoadPermission: true
    };
  },

  [ACTION.RECEIVE_LOAD_PERMISSION]: (state: MyNotificationsState, action: actions.ReceiveLoadPermission): MyNotificationsState => {

    return {
      ...state,
      permission: action.permission,
      fetchingLoadPermission: false
    };
  },

  [ACTION.FAIL_LOAD_PERMISSION]: (state: MyNotificationsState, action: actions.FailLoadPermission): MyNotificationsState => {

    return {
      ...state,
      fetchingLoadPermission: false
    };
  },

  [ACTION.REQUEST_LOAD_CONSENTS]: (state: MyNotificationsState, action: actions.RequestLoadConsents): MyNotificationsState => {

    return {
      ...state,
      fetchingLoadConsents: true
    };
  },

  [ACTION.RECEIVE_LOAD_CONSENTS]: (state: MyNotificationsState, action: actions.ReceiveLoadConsents): MyNotificationsState => {

    return {
      ...state,
      consents: action.consents,
      fetchingLoadConsents: false
    };
  },

  [ACTION.FAIL_LOAD_CONSENTS]: (state: MyNotificationsState, action: actions.FailLoadConsents): MyNotificationsState => {

    return {
      ...state,
      fetchingLoadConsents: false
    };
  },

  [ACTION.REQUEST_LOAD_CONSENT]: (state: MyNotificationsState, action: actions.RequestLoadConsent): MyNotificationsState => {

    return {
      ...state,
      fetchingLoadConsent: true
    };
  },

  [ACTION.RECEIVE_LOAD_CONSENT]: (state: MyNotificationsState, action: actions.ReceiveLoadConsent): MyNotificationsState => {

    return {
      ...state,
      consent: action.consent,
      fetchingLoadConsent: false
    };
  },

  [ACTION.FAIL_LOAD_CONSENT]: (state: MyNotificationsState, action: actions.FailLoadConsent): MyNotificationsState => {

    return {
      ...state,
      fetchingLoadConsent: false
    };
  },

  [ACTION.CLEAR_CONSENT]: (state: MyNotificationsState, action: actions.ClearConsent): MyNotificationsState => {

    return {
      ...state,
      consent: undefined
    };
  },
  [ACTION.PROCESS_CONSENT_FAILED]: (state: MyNotificationsState, action: any): MyNotificationsState => {
    return {
      ...state,
      validation: action.errors
    };
  },
  [ACTION.CLEAR_VALIDATION]: (state: MyNotificationsState, action: any): MyNotificationsState => {
    const validationCurrent = state.validation && state.validation[action.formName];

    if (!validationCurrent) {
      return state;
    }

    return {
      ...state,
      validation: {
        ...state.validation,
        [action.formName]: undefined
      }
    };
  }
};

export const reducer: Reducer<MyNotificationsState> = (state: MyNotificationsState = INITIAL_NOTIFICATIONS_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || simpleFormReducer(STATE.myNotifications)(state, action);
};
